"use client";

import React from "react";
import { Github, Instagram, Twitter, Terminal } from "lucide-react";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-8">
        {[1, 2, 3].map((_, i) => <div key={i} data-index={i} className="space-y-4">
            <div className="h-4 w-24 bg-muted/20 animate-pulse rounded-md" />
            <div className="h-4 w-32 bg-muted/20 animate-pulse rounded-md" />
            <div className="h-4 w-20 bg-muted/20 animate-pulse rounded-md" />
          </div>)}
      </div>;
  }
  return <NavigationMenu viewport={false} className="w-full max-w-none justify-start items-start">
      <NavigationMenuList className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-12 gap-y-4 w-full !items-start !justify-start flex-col sm:flex-row">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i} className="w-full list-none">
            <NavigationMenuLink asChild className="w-full justify-start hover:bg-transparent focus:bg-transparent data-[active=true]:bg-transparent px-0 py-1.5 text-muted-foreground hover:text-primary focus:text-primary transition-colors">
              <Link to={item.href || "#"} className="flex items-center gap-2 group">
                <span className="text-primary opacity-0 group-hover:opacity-100 transition-opacity duration-200 font-default">
                  {">"}
                </span>
                <span className="group-hover:translate-x-1 transition-transform duration-200 font-default text-lg tracking-wider">
                  {item.label}
                </span>
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  const socials = [{
    name: "Twitter",
    icon: Twitter,
    href: "#"
  }, {
    name: "Instagram",
    icon: Instagram,
    href: "#"
  }, {
    name: "Github",
    icon: Github,
    href: "#"
  }];
  return <section data-section-id="264819" id="footer" className="bg-background text-foreground font-sans py-12 px-6 md:px-12 border-t border-primary/20 relative overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none bg-[linear-gradient(transparent_50%,rgba(255,100,0,0.05)_50%)] bg-[length:100%_4px] opacity-30 z-0" />

      <div className="max-w-7xl mx-auto relative z-10 flex flex-col min-h-[400px] justify-between">
        
        {}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8 mb-16 border-b border-primary/10 pb-8">
          <div className="flex items-center gap-4">
            <Terminal className="size-6 text-primary" strokeWidth={2} />
            <Link to="/" className="inline-block">
              <WvcLogo className="h-10 w-auto text-primary" />
            </Link>
          </div>
          
          <div className="flex items-center gap-6">
            {socials.map((social, i) => {
            const Icon = social.icon;
            return <Link key={social.name} to={social.href} data-index={i} className="text-muted-foreground hover:text-primary transition-all duration-300 hover:scale-110 p-2 rounded-md border border-transparent hover:border-primary/30" aria-label={social.name}>
                  <Icon className="size-6" strokeWidth={1.5} />
                </Link>;
          })}
          </div>
        </div>

        {}
        <div className="flex-grow mb-16">
          <div className="mb-6 text-xs text-primary font-mono uppercase tracking-[0.3em]">
            {">"} ROLLING_TACOS_NAV
          </div>
          <MenuProvider menu_id="17">
            <FooterMenuConsumer />
          </MenuProvider>
        </div>

        {}
        <div className="flex flex-col sm:flex-row justify-between items-end sm:items-center gap-6 pt-8 border-t border-primary/10 text-[10px] font-mono text-muted-foreground uppercase tracking-widest">
          <div className="flex items-center gap-2">
            <span className="text-primary">{">"}</span>
            <span>EST. 2024</span>
          </div>

          <Button variant="outline" size="icon" onClick={scrollToTop} className="rounded-md border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300 size-12 shadow-lg shadow-primary/20" aria-label="Back to top">
            <span className="text-2xl leading-none font-default">^</span>
          </Button>

          <div className="flex items-center gap-2">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-md bg-primary opacity-75"></span>
              <span className="relative inline-flex rounded-md h-2 w-2 bg-primary"></span>
            </span>
            <span>TRUCK.STATUS [ON_THE_MOVE]</span>
          </div>
        </div>
      </div>
    </section>;
}